/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import { Helmet } from "react-helmet"
import { Link } from "gatsby"
import CookieConsent from "react-cookie-consent"
import Footer from "../components/footer/footer"
import "./animate.css"
import "./layout.css"

const Layout = ({children}) => {
  return (
    <div className="screen-orientation">
       <Helmet>
        <meta name="google-site-verification" content="gk3K-_nsVIWkPHE3VTIrRbQJc9sNKqkLq40IyqDZZXE" />
        <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;900&display=swap" rel="stylesheet"></link>
      </Helmet>
      <CookieConsent
          location="bottom"
          buttonText="Accept"
          cookieName="gatsby-gdpr-google-analytics"
          style={{ background: "#000000" }}
          buttonStyle={{ color: "#ffffff", backgroundColor: "#0085ff" }}
      >
        By visiting Firststringdigital.com you accept our use of cookies and agree to our {" "}
        <Link to="/privacy-policy" >Privacy Policy</Link>
      </CookieConsent>
      <main>{children}</main>
      <Footer />
    </div>
  )
}

export default Layout
